import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { emotionsFinanceSection } from './sections/emotions-finance';
import { finfluencerSection } from './sections/finfluencer';
import { fakeNewsSection } from './sections/fake-news';
import { protectionSection } from './sections/protection';
import { conclusionSection } from './sections/conclusion';

export const content: BlogPostContent = {
  sections: [
    introSection,
    emotionsFinanceSection,
    finfluencerSection,
    fakeNewsSection,
    protectionSection,
    conclusionSection
  ]
};
